import React from 'react';
import MarkdownIt from 'markdown-it';
import ContentfulImage, { FluidImage } from '../../../../../components/ContentfulImage';
import s from '../../Feature.module.scss';
import RichText from '../../../../../components/RichText';
import { CaseStudyFeature } from '../../../../../constants/types';

const md = new MarkdownIt({
  html: true,
  linkify: false,
});

interface ViewType5Props {
  item: CaseStudyFeature;
}

const ViewType5: React.FC<ViewType5Props> = ({ item }) => {
  const { description, imageSliders = [], hideTitle, title, backgroundColor } = item;

  const imageList = [...(imageSliders ?? [])];
  let lastImage;
  
  if (imageList.length % 2 !== 0) {
    lastImage = imageList.pop();
  }

  return (
    <div className={s.root}>
      <div
        className={[s.viewType5, s.container].join(' ')}
        style={{ background: backgroundColor || '' }}
        data-testid="viewtype5-container"
      >
        <div className={s.subContainer}>
          <div className={s.textBlock}>
            {!hideTitle && (
              <h2 className={s.title} data-testid="viewtype5-title">
                {title}
              </h2>
            )}
            <div className={s.content} data-testid="viewtype5-content">
              {description && <RichText data={description}/>}
            </div>
          </div>
        </div>
        <div className={s.imageSection}>
          {imageList.map((img) => 
             <div className={s.imageItem} key={`${img.id}${Math.random()}`}>
              {img?.image?.fluid && <ContentfulImage
                alt={title}
                key={img.id}
                fluid={img?.image?.fluid}
                dataTestId={`viewtype5-image-${img.id}`}
              />}
              </div>
          )}

        </div>
        {lastImage && (
          <div className={s.lastImage}>
            <ContentfulImage
              fluid={lastImage.image.fluid}
              alt={lastImage.image.fluid.alt || title}
              dataTestId="viewtype5-last-image"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewType5;
